import React from 'react';
import Icon from './icon';

const EmailIcon = props => {
    const { id, className } = props;
    return (
        <Icon id={id} className={className}>
            <svg
                width="25"
                height="25"
                viewBox="0 0 50 50"
                fill="black"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M4 10C4 8.89543 4.89543 8 6 8H44C45.1046 8 46 8.89543 46 10V40C46 41.1046 45.1046 42 44 42H6C4.89543 42 4 41.1046 4 40V10ZM6 10V11.333L25 25L44 11.333V10H6ZM6 15.5V40H44V15.5L25 29L6 15.5Z" />
            </svg>
        </Icon>
    );
};

export default EmailIcon;
